import React from 'react';
import { Pagination as BsPagination } from 'react-bootstrap';
import { strings } from '../../resources/strings';
import { DropdownButton, DropdownButtonAlignment, DropdownButtonColor, DropdownButtonDirection } from '../DropdownButton/DropdownButton';
import { If } from '../If/If';
import { Container, Description, LeftContainer, TotalAmount, RightContainer, DescriptionCentered } from './styles';

interface IPaginationProps {
    currentPage: number;
    currentPageSize: number;
    amountOfPages: number;
    totalAmount: number;
    pageSize: number;
    changePageSize?: (pageSize: number) => void;
    changePage?: (page: number) => void;
    descriptionForNoneRecordFound?: string;
    hidePageSizeOptions?: boolean;
    filtering?: boolean;
    backgroundColor?: string;
    padding?: string;
}

export const Pagination: React.FC<IPaginationProps> = ({
    currentPage,
    currentPageSize,
    amountOfPages,
    totalAmount,
    pageSize,
    changePageSize,
    changePage,
    descriptionForNoneRecordFound,
    hidePageSizeOptions,
    filtering,
    backgroundColor,
    padding
}) => {

    if (!amountOfPages) {
        return (
            <Container backgroudColor={backgroundColor} padding={padding}>
                <DescriptionCentered>
                    <strong>{filtering ? '...' : descriptionForNoneRecordFound || strings.NoneRecordFoundForInformedFilters}</strong>
                </DescriptionCentered>
            </Container>
        );
    }

    const pageSizeOptions = [
        {key:'0', text:'Sem paginação'},
        {key:'75', text:'75'},
        {key:'50', text:'50'},
        {key:'25', text:'25'}
    ];

    const pageSizeText = pageSize > 0 ? pageSize.toString() : pageSizeOptions[0].text;

    return (
        <Container backgroudColor={backgroundColor} padding={padding}>
            <LeftContainer>
                <BsPagination size="sm" style={{marginRight:'10px'}}>
                    {currentPage > 2 ? <BsPagination.First disabled={filtering} onClick={() => changePage ? changePage(1) : null} /> : null}
                    {currentPage > 1 ? <BsPagination.Prev disabled={filtering} onClick={() => changePage ? changePage(currentPage-1) : null} /> : null}
                    <BsPagination.Item disabled>{currentPage}</BsPagination.Item>
                    {currentPage < amountOfPages ? <BsPagination.Next disabled={filtering} onClick={() => changePage ? changePage(currentPage+1) : null} /> : null}
                    {currentPage < amountOfPages-1 ? <BsPagination.Last disabled={filtering} onClick={() => changePage ? changePage(amountOfPages) : null} /> : null}
                </BsPagination>
                <Description>
                    {currentPage} de {amountOfPages}
                </Description>
                <TotalAmount>
                    ({totalAmount} registro{totalAmount > 1 ? 's' : ''})
                </TotalAmount>
            </LeftContainer>
            <RightContainer>
                <If condition={!hidePageSizeOptions}>
                    <DropdownButton
                        items={pageSizeOptions}
                        defaultStyle={true}
                        small={true}
                        buttonColor={DropdownButtonColor.Secondary}
                        outlineButton={true}
                        direction={DropdownButtonDirection.DropToUp}
                        alignment={DropdownButtonAlignment.End}
                        minWidthMenu={'55px'}
                        text={pageSizeText}
                        clickItem={(key) => changePageSize ? changePageSize(+key) : null}
                        disabled={filtering}
                    />
                </If>
            </RightContainer>
        </Container>
    );
}